export default class Accordion {
  constructor ( node ) {
  	this.wrapElem= node.getElementsByClassName('accordion-wrap')[0];
  	this.btn= this.wrapElem.getElementsByClassName('accordion-btn');
		this.items= this.wrapElem.querySelectorAll('.accordion-item');
		this.selected= null;
  }


	run ( defaultKey ) {
		const keys= Object.keys(this.btn);
		keys.map( (val, key) => {
			this.btn[val].addEventListener('click', (e) => {
				const panelWrap= e.currentTarget.closest('.accordion-item')
					,	isToggle= panelWrap.classList.contains('accordion-active');
				if( this.selected ) this.close(this.selected);
				if( isToggle ) return;
				this.open(panelWrap);
			});
		});
		if( defaultKey != undefined ) this.btn[defaultKey].click();
	}

	open ( panelWrap ) {
		const panel= panelWrap.getElementsByClassName('accordion-target')[0];
		panelWrap.classList.add('accordion-active');
    panel.style.maxHeight = panel.scrollHeight + "px";
    this.selected= panelWrap;
	}

	close ( panelWrap ) {
		const panel= panelWrap.getElementsByClassName('accordion-target')[0];
		if( panel ) {
			panelWrap.classList.remove('accordion-active');
			panel.style.maxHeight = null;
		}
	}

	allClose () {
		_jh.each(this.items, (i,v)=> {
			this.close(v);
			this.selected= null;
		});
	}

	destroy () {
		
	}
}